// Opciones excluyentes como chips: la elegida va prendida. El mismo control en todos los editores.
import { ScopeChip, type ScopeChipTone } from '@/shared/patterns/ScopeChips';

/** Violeta, como el `data-tone="promo"` del mock. */
export const CHOICE_TONE: ScopeChipTone = {
    chip: 'border-promo-soft-border bg-promo-soft text-promo',
    dot: 'bg-promo',
};

export function ChoiceChips<T extends string>({
    label,
    options,
    value,
    onPick,
    disabled = false,
}: {
    /** Nombre del grupo; sin él, lo nombra el `EditorField` que lo envuelve. */
    label?: string;
    options: readonly { value: T; label: string; disabled?: boolean }[];
    value: T;
    onPick: (value: T) => void;
    disabled?: boolean;
}) {
    return (
        <div
            {...(label === undefined ? {} : { role: 'group', 'aria-label': label })}
            className="flex flex-wrap gap-1.5"
        >
            {options.map((option) => (
                <div key={option.value} className="w-auto">
                    <ScopeChip
                        dim="tier"
                        tone={CHOICE_TONE}
                        label={option.label}
                        selected={value === option.value}
                        disabled={disabled || option.disabled === true}
                        onToggle={() => {
                            onPick(option.value);
                        }}
                    />
                </div>
            ))}
        </div>
    );
}
